import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { useModal } from '../ModalContext';
export const PartnerPathway = () => {
  const {
    openTalkToUs
  } = useModal();
  return <section id="for-partners" className="w-full bg-white py-10 md:py-14" data-id="element-219" data-mp="rzs82iihwsm">
      <div className="container mx-auto px-5 sm:px-8" data-id="element-220" data-mp="ucir42c5fha">
        <div className="mx-auto max-w-4xl border-y border-gray-200 py-7 md:py-9" data-id="element-221" data-mp="3rxhq17nruq6k">
          <div className="grid items-center gap-6 md:grid-cols-12 md:gap-10" data-id="element-222" data-mp="3mzzm5vom315f">
            <div className="md:col-span-6" data-id="element-223" data-mp="3i8rccyjdddrq">
              <p className="mb-3 text-xs font-semibold uppercase tracking-[0.16em] text-gray-600" data-id="element-224" data-mp="3i7y6dzs8isan">
                For curriculum and coaching organizations
              </p>
              <h2 className="font-serif text-2xl font-normal leading-snug text-cyan-950" data-id="element-225" data-mp="398ukyp5li0sz">
                How your materials land in classrooms
              </h2>
            </div>

            <div className="md:col-span-6" data-id="element-226" data-mp="2za5edsj5g2s1">
              <p className="text-[15px] leading-relaxed text-gray-600" data-id="element-227" data-mp="2zb6sk5vgp5dz">
                Understand how educators use your materials, where support is needed, and how implementation changes over time.
              </p>

              <button type="button" onClick={openTalkToUs} className="group mt-5 inline-flex items-center gap-2 text-sm font-medium text-primary-700 underline decoration-primary-300 underline-offset-4 transition-colors hover:text-primary-800" data-id="element-228" data-mp="a67lpwhti4i6">
                Nisa for implementation partners
                <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-0.5" strokeWidth={1.75} data-id="element-229" data-mp="o5fjqm28v6ks" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
};